import React, { FC, useContext, useEffect, useRef } from "react";
import classNames from "classnames";
import { DialogsContext, EventsContext } from "@app/pippa/provider";
import {
  MessageBody,
  Typing,
  StreamingMessage,
  WelcomeMessage,
} from "@app/pippa/components/message";
import { MessageTypes, QuickReplyType } from "@app/pippa/models";
import { shouldShowAvatarLogo } from "./helpers/shouldShowAvatarLogo";
import "./messageContainer.scss";

const MessageContainer: FC = () => {
  const messagesEnd = useRef<HTMLDivElement>(null);
  const {
    eventsProviderState: { messages, streamingMessage, showTyping },
  } = useContext(EventsContext);
  const { acknowledgementDialog } = useContext(DialogsContext);

  const isAcknowledgementOpen = Boolean(acknowledgementDialog?.getDialog());
  const conversationStarted = messages.some((message) => message.isSendByUser);
  const hasNoticeMessage = messages.some((message) => message.isError);
  const visibleMessages = messages.filter(
    (message) =>
      message.type !== MessageTypes.INTRO &&
      (message.isSendByUser || Boolean(message.text))
  );
  const lastMessage = messages[messages.length - 1];
  const initialQuickReplies =
    (lastMessage?.quickReplies as QuickReplyType[]) ?? [];

  const showWelcomeScreen = !conversationStarted && !hasNoticeMessage;

  useEffect(() => {
    scrollToBottom();
  }, [messages?.length, showTyping, streamingMessage?.text]);

  const scrollToBottom = () => {
    if (messagesEnd.current) {
      messagesEnd.current.scrollIntoView();
    }
  };

  return (
    <div
      className={classNames("message-container__wrap-container", {
        initial: !conversationStarted,
      })}
    >
      {showWelcomeScreen
        ? !isAcknowledgementOpen && (
            <WelcomeMessage quickReplies={initialQuickReplies} />
          )
        : visibleMessages.map((message, index) => (
            <MessageBody
              key={message.id}
              message={message}
              messageIndex={index}
              isShowLogo={shouldShowAvatarLogo(visibleMessages, index)}
              isLastMessage={visibleMessages.length === index + 1}
              showTyping={showTyping}
            />
          ))}
      {streamingMessage?.text && (
        <StreamingMessage
          message={streamingMessage}
          isShowLogo={shouldShowAvatarLogo(visibleMessages)}
        />
      )}
      {showTyping && <Typing />}
      <div ref={messagesEnd} />
    </div>
  );
};

export default MessageContainer;
